var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "signup-professional-full-screen-modal",
      attrs: {
        id: "signup-professional-modal",
        centered: "",
        "hide-header": "",
        "no-close-on-esc": "",
        "ok-variant": "primary"
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100 mr-2",
                      attrs: { variant: "secondary" },
                      on: { click: _vm.close }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Close")))]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleOk($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("signup.professional.modal.go"))
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", [
        _c("div", [
          _c("h1", { staticClass: "page-title mb-4" }, [
            _vm._v(_vm._s(_vm.$t("signup.professional.modal.title")))
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "signup-professional-text mt-2",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("signup.professional.modal.content.one") +
                  "<span style='color: white;'>" +
                  _vm.redirectConnexionUrl +
                  "</span>"
              )
            }
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "signup-professional-text",
            domProps: {
              innerHTML: _vm._s(_vm.$t("signup.professional.modal.content.two"))
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-431354a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431354a1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/SignupProfessionalModal.vue
// module id = l97W
// module chunks = 0